import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getRoutePathById, allSiteMap } from '@bingads-webui-react/with-site-map';

import { IOverviewTableProps, IScopeContext } from './types';
import { GridDataTable } from './grid-data-table';
import { useStyles } from './overview-grid-card-style';

const MATCH_TYPE = {
  Exact: _TL_('Type: Exact'),
  Phrase: _TL_('Type: Phrase'),
  Broad: _TL_('Type: Broad'),
};

const getPopoverContentFunction = i18n => ({
  Name, MatchType, AdGroup, Campaign,
}: any) => {
  const matchType = MATCH_TYPE[MatchType] ? i18n.getString(MATCH_TYPE[MatchType]) : null;
  return (
    <>
      <div>{Name}</div>
      <div>{`${Campaign?.Name} > ${AdGroup?.Name}`}</div>
      {matchType && <div>{matchType}</div>}
    </>
  );
};

export function OverviewKeywordTable(props: IOverviewTableProps) {
  const { i18n } = props;
  const { scope } = useContext(ScopeContext) as IScopeContext;
  const { aid, cid, uid } = scope?.values;
  const classes = useStyles();

  const onFooterButtonClick = useCallback(() => {
    scope.save(getRoutePathById(allSiteMap, 'keywords'));
  }, [scope]);

  const getHref = useCallback((entityId: string) => {
    const route = getRoutePathById(allSiteMap, 'keywords');
    const search = `cid=${cid}&uid=${uid}&aid=${aid}&campaignId=${entityId}`;
    return `${route}?${search}`;
  }, [aid, cid, uid]);

  return (
    <div className={classNames(classes.gridStyle, 'ba-campaign-keyword-overview-table')}>
      <GridDataTable
        {...props}
        entityDisPlayName={i18n.getString(_TL_('Keyword'))}
        footerButtonConfigs={[
        {
          text: i18n.getString(_TL_('View all keywords')),
          onClick: onFooterButtonClick,
        },
      ]}
        getHref={getHref}
        getPopoverContent={getPopoverContentFunction(i18n)}
        entityType="Keyword"
      />
    </div>
  );
}
